import {
  INICIA_SEQUENCIA_ENTURMACAO,
  NOVO_SEQUENCIA_ENTURMACAO,
  BUSCA_SEQUENCIA_ENTURMACAO_EDICAO,
  INICIA_SEQUENCIA_ENTURMACAO_SUCESSO,
  SALVA_SEQUENCIA_ENTURMACAO_SUCESSO,
  REMOVE_SEQUENCIA_ENTURMACAO_SUCESSO,
  BUSCA_SEQUENCIA_ENTURMACAO_EDICAO_SUCESSO,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  LISTA_SEQUENCIA_ENTURMACAO,
  LISTA_SEQUENCIA_ENTURMACAO_SUCESSO,
  LIMPAR_SEQUENCIA_ENTURMACAO,
  APLICA_FILTRO_SEQUENCIA_ENTURMACAO,
  ALTERACAO_COMBO,
  ALTERACAO_CAMPO
} from "constants/ActionTypes";

const INIT_STATE = {
  // Configuração da Grid
  colunasGrid: [
    { titulo: 'Escola', propriedadeApi: 'escolaNome', alinhamento: 'left' },
    { titulo: 'Curso Origem', propriedadeApi: 'cursoOrigemNome', alinhamento: 'left' },
    { titulo: 'Série Origem', propriedadeApi: 'serieOrigemNome', alinhamento: 'left' },
    { titulo: 'Curso Destino', propriedadeApi: 'cursoDestinoNome', alinhamento: 'left' },
    { titulo: 'Série Destino', propriedadeApi: 'serieDestinoNome', alinhamento: 'left' }
  ],

  // Propriedades Globais
  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  carregandoLista: true,
  listGrid: [],
  listGridComFiltro: [],
  textoFiltro: '',
  cursoOrigemFiltro: null,
  cursoDestinoFiltro: null,
  serieOrigemFiltro: null,
  serieDestinoFiltro: null,
  sequenciaEnturmacaoCarregada: null,

  // Campos do Formulario
  id: 0,
  escolaId: null,
  cursoOrigemId: null,
  serieOrigemId: null,
  cursoDestinoId: null,
  serieDestinoId: null,
  
  // Listas auxiliares para selects (serão preenchidas pelo Saga se necessário, ou reutilizar reducers existentes)
  // Assumindo que o componente buscará listas de outras entidades ou o saga preencherá aqui se específico
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INICIA_SEQUENCIA_ENTURMACAO: {
      return {
        ...state,
        loader: true,
        listGrid: [],
        listGridComFiltro: [],
        carregandoLista: true
      };
    }
    case INICIA_SEQUENCIA_ENTURMACAO_SUCESSO: {
      return {
        ...state,
        loader: false,
        listGrid: action.payload,
        listGridComFiltro: action.payload,
        carregandoLista: false
      };
    }
    case LISTA_SEQUENCIA_ENTURMACAO: {
      return {
        ...state,
        loader: true,
        carregandoLista: true
      };
    }
    case LISTA_SEQUENCIA_ENTURMACAO_SUCESSO: {
      return {
        ...state,
        loader: false,
        listGrid: action.payload,
        listGridComFiltro: action.payload,
        carregandoLista: false
      };
    }
    case NOVO_SEQUENCIA_ENTURMACAO: {
      return {
        ...state,
        id: 0,
        escolaId: null,
        cursoOrigemId: null,
        serieOrigemId: null,
        cursoDestinoId: null,
        serieDestinoId: null,
        edicao: true,
        sequenciaEnturmacaoCarregada: null
      };
    }
    case BUSCA_SEQUENCIA_ENTURMACAO_EDICAO: {
      return {
        ...state,
        loader: true,
        edicao: true
      };
    }
    case BUSCA_SEQUENCIA_ENTURMACAO_EDICAO_SUCESSO: {
      const registro = action.payload;
      return {
        ...state,
        loader: false,
        id: registro.id,
        escolaId: registro.escolaId,
        cursoOrigemId: registro.cursoOrigemId,
        serieOrigemId: registro.serieOrigemId,
        cursoDestinoId: registro.cursoDestinoId,
        serieDestinoId: registro.serieDestinoId,
        sequenciaEnturmacaoCarregada: registro
      };
    }
    case SALVA_SEQUENCIA_ENTURMACAO_SUCESSO: {
      return {
        ...state,
        loader: false,
        edicao: false,
        showMessageSuccess: true,
        alertMessage: 'Registro salvo com sucesso!'
      };
    }
    case REMOVE_SEQUENCIA_ENTURMACAO_SUCESSO: {
      return {
        ...state,
        loader: false,
        showMessageSuccess: true,
        alertMessage: 'Registro removido com sucesso!'
      };
    }
    case LIMPAR_SEQUENCIA_ENTURMACAO: {
      return {
        ...state,
        id: 0,
        escolaId: null,
        cursoOrigemId: null,
        serieOrigemId: null,
        cursoDestinoId: null,
        serieDestinoId: null,
        edicao: false,
        sequenciaEnturmacaoCarregada: null
      };
    }
    case APLICA_FILTRO_SEQUENCIA_ENTURMACAO: {
      const filtro = action.payload ? action.payload.toLowerCase() : '';
      let listaFiltrada = [];
      
      if (state.listGrid && state.listGrid.length > 0) {
        if (filtro !== '') {
          listaFiltrada = state.listGrid.filter(item => {
            const escola = item.escolaNome ? item.escolaNome.toLowerCase() : '';
            const cursoOrigem = item.cursoOrigemNome ? item.cursoOrigemNome.toLowerCase() : '';
            return escola.includes(filtro) || cursoOrigem.includes(filtro);
          });
        } else {
          listaFiltrada = state.listGrid;
        }
      }
      
      return {
        ...state,
        listGridComFiltro: listaFiltrada,
        textoFiltro: action.payload
      };
    }
    case ALTERACAO_COMBO: {
        const valorBruto = action.payload.valor;
        const valorNormalizado = (valorBruto && typeof valorBruto === 'object')
          ? (valorBruto.id !== undefined ? valorBruto.id : (valorBruto.value !== undefined ? valorBruto.value : valorBruto))
          : valorBruto;
        return { ...state, [action.payload.nomeCombo]: valorNormalizado };
    }
    case ALTERACAO_CAMPO: {
        return { ...state, [action.payload.target.name]: action.payload.target.value };
    }
    case ON_SHOW_LOADER: {
      return { ...state, loader: true };
    }
    case ON_HIDE_LOADER: {
      return { ...state, loader: false };
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessageSuccess: false,
        showMessageError: true,
        loader: false
      };
    }
    case ON_SHOW_SUCCESS_MESSAGE: {
        return {
          ...state,
          alertMessage: action.payload,
          showMessageSuccess: true,
          showMessageError: false,
          loader: false
        };
      }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
        loader: false
      };
    }
    default:
      return state;
  }
};
